import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';

import { MakeProvider } from '../../../../helpers/base-control-value-accessor';
import { FormValue } from '../../../entities/form-value.entity';
import { ShFormTextareaComplexBaseComponent } from '../base-complex/form-textarea-complex-base.component';
import { NgClass, AsyncPipe } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

@Component({
    selector: 'sh-form-textarea-base',
    templateUrl: '../base-complex/form-textarea-complex-base.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [MakeProvider(ShFormTextareaBaseComponent)],
    standalone: true,
    imports: [ReactiveFormsModule, NgClass, AsyncPipe]
})
export class ShFormTextareaBaseComponent extends ShFormTextareaComplexBaseComponent {
    constructor(changeDetectorRef: ChangeDetectorRef) {
        super(changeDetectorRef);
    }

    propagateChange(fv: FormValue<string>): void {
        super.propagateSimpleChange(FormValue.unwrap(fv));
    }

    writeValue(obj: any): void {
        super.writeValue(FormValue.wrap(obj));
    }
}
